/*=========================================================================================
  File Name: module-agreement-mutations.js
  Description: Agreement Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {
  updateLinkHistoryAgreement(state, res) {
    state.LinkHistoryAgreement = res;
  },

  updateAgreement(state, res) {
    state.Agreement = res;
  },

  updateProductAgreement(state, res) {
    state.ProductAgreement = res;
  }
};